import { Button, Grid, Typography } from "@mui/material";
import React from 'react';

export interface IBannerRegisterDataProps {
    title: string;
    description?: React.ReactNode;
    imagen: string;
    ctaTitle: string;
    ctaEvent: string;
}

export const BannerRegisterData = ({title, description, imagen, ctaTitle, ctaEvent}: IBannerRegisterDataProps): JSX.Element => {

  return (
    <Grid container
        style={{ 
            backgroundImage: `url(${imagen})`, 
            backgroundSize: 'cover', 
            backgroundPosition: 'center', 
            minHeight: '20vh', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            backgroundBlendMode: 'darken',
        }}
    >
        <Grid item
            style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center',
            padding: '4rem'
            }}
        >
            <Typography variant="h2" component="strong" style={{color:'#ffffff', textAlign:'center'}} >{title}</Typography>
            <Typography variant="body1" component="p"  
                style={{ 
                    marginTop: '2rem',
                    textAlign: 'center',
                    maxWidth: '70ch',
                    color: '#ffffff'
                }}
            >
                {description}
            </Typography>
            <Button variant="contained" 
                style={{ 
                    marginTop: '2rem',
                    backgroundColor: '#EE2B7B',
                    borderRadius: '2rem',
                    textTransform: 'none',
                    color: '#ffffff',
                }}
                component="a"
                href={ctaEvent}
                target="_blank"
                rel="noopener noreferrer"
            >
                {ctaTitle}
            </Button>
        </Grid>
    </Grid>
  )
}